// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1qZ7I","errorLogs":"styles_errorLogs__2InCm"};